import React from "react";
import Videoframe from "./multimedia/Videoframe";

const Playfools = () => {
  return (
    <section id="playfools" className="w-full h-auto px-16 sm:px-0 pt-32 pb-10">
      <div className="w-full pb-5">
        <div className="pb-10 text-center">
          <h2 className="text-5xl font-FreckleFace capitalize pb-2">
            laughters make you healthy!
          </h2>
          <h3 className="text-xl">
            Come to Doctor Phil, He has your prescriptions and you will feel
            good.
          </h3>
        </div>
      </div>
      <div className="grid grid-cols-12 2xl:grid-cols-10 xl:grid-cols-8 lg:grid-cols-7 md:grid-cols-5 sm:grid-cols-4 gap-10 xl:gap-8 gap-y-10 w-full justify-center items-center">
        <div className="col-span-4 sm:col-span-12">
          <Videoframe
            title="January 3, 2025"
            des="comedy show"
            vidId="aEvKjYScbO0"
            className="w-full"
          />
        </div>
        <div className="col-span-4 sm:col-span-12">
          <Videoframe
            title="October 9, 2023"
            des="comedy show"
            vidId="sKpauzYNo1Y"
          />
        </div>
        <div className="col-span-4 sm:col-span-12">
          <Videoframe
            title="at Nottingham"
            des="comedy show"
            vidId="8IZqk6loa4Y"
          />
        </div>

        <div className="col-span-4  sm:col-span-12">
          <Videoframe
            title="May 27, 2023"
            des="comedy show"
            vidId="Urle0VABeA4"
          />
        </div>
        <div className="col-span-4 sm:col-span-12">
          <Videoframe
            title="April 17, 2023"
            des="comedy show"
            vidId="u_zcoXO7SYo"
          />
        </div>
        <div className="col-span-4 sm:col-span-12">
          <Videoframe
            title="Library terror Washington DC"
            des="comedy show"
            vidId="P0VSuiB71Os"
          />
        </div>

        <div className="col-span-4 sm:col-span-12">
          <Videoframe
            title="Library tavern"
            des="comedy show"
            vidId="ER2Eq3f3eas"
          />
        </div>
        <div className="col-span-4 sm:col-span-12">
          <Videoframe
            title="Nottingham Comedy Club"
            des="comedy show"
            vidId="A9T5k2EOTSM"
          />
        </div>
      </div>
    </section>
  );
};

export default Playfools;
